/* eslint-disable max-len */
import { offeringTypes } from '../types/offering.types';

const initState = {
  offerts: {
    data: [],
    loading: false,
    message: ''
  },
  myOfferts: {
    data: [],
    loading: false,
    message: ''
  },
};

const offeringReducer = (state = initState, action) => {
  switch (action.type) {
    case offeringTypes.HANDLE_OFFERT_REQUEST:
      return { ...state, offerts: { ...state.offerts, loading: true } };
    case offeringTypes.HANDLE_OFFERT_SUCCESS:
      return {
        ...state,
        offerts: {
          ...state.offerts,
          loading: false,
          data: action.payload.body
        }
      };
    case offeringTypes.HANDLE_OFFERT_FAILED:
      return {
        ...state,
        offerts: {
          ...state.offerts,
          loading: false,
          error: action.payload.error
        }
      };
    case offeringTypes.GET_MY_OFFERTS_REQUEST:
      return { ...state, myOfferts: { ...state.myOfferts, loading: true } };
    case offeringTypes.GET_MY_OFFERTS_SUCCESS:
      return {
        ...state,
        myOfferts: {
          ...state.myOfferts,
          loading: false,
          data: action.payload.body
        }
      };
    case offeringTypes.GET_MY_OFFERTS_FAILED:
      return {
        ...state,
        myOfferts: {
          ...state.myOfferts,
          loading: false,
          error: action.payload.error
        }
      };
    case offeringTypes.RESET_OFFERTS:
      return {
        ...state,
        offerts: {
          data: [],
          loading: false,
        }
      };
    case offeringTypes.RESET_MY_OFFERTS:
      return {
        ...state,
        myOfferts: {
          data: [],
          loading: false,
        }
      };
    default:
      return state;
  }
};

export default offeringReducer;